export default class CategoryFilter {
    constructor() {
        var _a, _b;
        this.page = 1;
        this.filterBar = document.querySelector('[data-post-filter]');
        if (!this.filterBar)
            return;
        this.categories = this.filterBar.querySelectorAll('[data-category]');
        this.postsContainer = document.querySelector('[data-posts]');
        this.loadMoreButton = document.querySelector('[data-load-more]');
        this.ajaxApiUrl = window.localize_script.admin_ajax + '?action=load_more_posts';
        this.activeCategory = (_b = (_a = document.querySelector('.active[data-category]')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-category')) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        this.addEventListeners();
    }
    addEventListeners() {
        this.categories.forEach((category) => {
            category.addEventListener('click', (event) => {
                // set category parameter to url
                const selectedCategory = category.getAttribute('data-category');
                this.toggleCategory(selectedCategory);
            });
        });
        this.loadMoreButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.page++;
            this.loadInfo();
            this.loadPosts();
        });
    }
    toggleCategory(category) {
        this.activeCategory = category;
        if (category === 'all') {
            window.history.pushState(null, '', window.location.pathname);
        }
        else {
            window.history.pushState(null, '', `?post_cat=${category}`);
        }
        // Set active
        this.categories.forEach((category) => {
            category.classList.remove('active');
            if (category.getAttribute('data-category').toLowerCase() === this.activeCategory) {
                category.classList.add('active');
            }
        });
        this.page = 1;
        this.loadInfo();
        this.loadPosts();
    }
    loadInfo() {
        const loadInfo = this.postsContainer.getAttribute('data-posts').split(',');
        this.loadMoreInfo = {
            load_more: false,
            page: this.page,
            posts_per_page: parseInt(loadInfo[1]),
            max_pages: parseInt(loadInfo[2])
        };
        if (this.activeCategory !== 'all') {
            this.loadMoreInfo.category = parseInt(this.activeCategory);
        }
        else {
            this.loadMoreInfo.category = this.activeCategory;
        }
    }
    loadPosts() {
        const options = {
            method: 'POST',
            body: JSON.stringify(this.loadMoreInfo)
        };
        fetch(this.ajaxApiUrl, options)
            .then(response => response.json())
            .then((response) => {
            this.apiResults = response.data.html;
            if (response.success === 0 || !response.data.has_more) {
                this.loadMoreInfo.load_more = false;
                this.loadMoreButton.parentElement.classList.add('hidden');
            }
            else {
                this.loadMoreButton.parentElement.classList.remove('hidden');
                this.loadMoreInfo.load_more = true;
            }
            this.setDomElements();
        })
            .catch((error) => {
            console.error('Fetch error:', error);
        });
    }
    setDomElements() {
        if (!this.apiResults) {
            return;
        }
        if (this.page === 1) {
            this.postsContainer.innerHTML = this.apiResults;
        }
        else {
            this.postsContainer.insertAdjacentHTML('beforeend', this.apiResults);
        }
    }
}
